import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Link} from 'react-router-dom';
import {Button} from 'primereact/button';

import { DATATABLE_CONFIG, SLA_SUBMENU_ID } from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';

class SLAMaster extends Component {
    state = {
        display : true,
        departmentList : [
            {
                label: '---Select Concerned Department---',
                value : null
            },
            {
                label: 'IT',
                value : 'IT'
            },
            {
                label: 'Finance Mangement',
                value : 'Finance Mangement'
            }
        ],
        dataTableValue: [{
            empno : "6000449",
            emptype : "Permanent",
            firstname : "Kristeine Lim",
            position : "Demo System Auto Generated",
            email : "swcaldt1ws@inbox-me.top",
            reporting : "COMPENSATION & BENEFITS"
        },{
            empno : "6000450",
            emptype : "Permanent",
            firstname : "Kristeine Lim",
            position : "Demo System Auto Generated",
            email : "swcaldt1ws@inbox-me.top",
            reporting : "Siddiq"
        },
        {
             empno : "6000451",
            emptype : "Permanent",
            firstname : "Kristeine Lim",
            position : "Demo System Auto Generated",
            email : "swcaldt1ws@inbox-me.top",
            reporting : "Siddiq"
        }
    ],

    selectedItems:[]
    }

   

    actionTemplate = (rowData, column) => {
        //let rowIndex = column.rowIndex;
        return <div className="actionCenter">
            
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
            <Link to={"/SLA-master/edit/"+rowData.slaid}><Button type="button" icon="pi pi-pencil" className="p-button-info" ></Button></Link>
            }

            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
            <Link to={"/SLA-master/view/"+rowData.slaid}><Button type="button" icon="pi pi-eye" className="p-button-secondary" ></Button></Link>
            }
            
        </div>;
    }


  

    componentDidMount(){        
        this.props.getMasterTableList('HDS/GetSla'); 

        this.getAccess = HASACCESS(SLA_SUBMENU_ID);
    }

  
    render() { 
        
        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        let tableData = []    
        if(this.props.tableLists && this.props.tableLists.length > 0){
            tableData = this.props.tableLists;
        }
    

        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }


        return (
            <div className="p-grid padding">
               { this.props.loading && <div className="page-loader"></div>}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
               {/* <Toast ref={(el) => this.growl = el} /> */}
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>SLA Master</h1>
               
                        <div className="p-grid">
                           

                            <div className="p-col-12  p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) &&
                                <Link to="/SLA-master/add/new"><Button style={{float: 'right'}} label="Add SLA" icon="pi pi-plus" className="ml1" /></Link>
                                }

                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!==false) &&
                                <Button onClick={this.delete} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger"/>
                                }
                                
                                
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>


                            
                        <DataTable value={tableData} selection={this.state.selectedItems} onSelectionChange={e => this.setState({selectedItems: e.value})}
                         globalFilter={this.state.globalFilter}  header={header} {...DATATABLE_CONFIG} >                                
                                <Column selectionMode="multiple" style={{width:'3em'}}/>
                                <Column field="slaname" header="SLA Name" sortable={true} style={{width:'12em'}} />
                                <Column field="description" header="Description"  />                                
                                <Column field="supportteam" header="Service Queue" />
                                <Column field="validfrom" header="Valid From" />
                                <Column field="validto" header="Valid To"  />
                                <Column field="vendorid" header="Vendor" />
                                <Column field="contractno" header="SContract No" />
                                <Column field="action" body={this.actionTemplate} header="Action"/>
                            </DataTable>
                        </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        tableLists : state.master.tableLists,
    }
}
  
const mapDispatchToProps = dispatch => {
    return{
        dynamicDeleteProcess: (model,data,func) => dispatch(actions.dynamicDeleteProcess(model,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(SLAMaster);